import React from 'react'

export default props => <p className="text-center text-cheflojo text-lg m-auto py-2 font-bold">{props.children}</p>